import { useRef, useState } from 'react'

export default function useHeightObserver() {
  const [height, setHeight] = useState(0)

  const observer = useRef(
    new ResizeObserver(([entry]) => {
      setHeight(entry.contentRect.height)
    })
  )

  return { height, resizeObserver: observer.current }
}
